



import { Vue, Component, Prop, Provide } from "vue-property-decorator";
@Component
export default class UnderConstruction extends Vue {

}
